import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtil } from '../kt';

export class DateValidator {
   static readonly DateOfBirth = (minAge: number = 18): ValidatorFn => {
      const date: Date = new Date();
      return (control: AbstractControl): ValidationErrors | null => {
         const dateOfBirthStr: string | null = control?.value;

         if (!dateOfBirthStr) {
            control.setErrors({ DateOfBirth: true });
            return { DateOfBirth: true };
         }

         const dateOfBirth = new Date(dateOfBirthStr);
         const age = DateUtil.calculateAge(dateOfBirth);

         // check if date is valid and person is at least 18 years old
         if (isNaN(dateOfBirth.getTime()) || age < minAge || dateOfBirth > date) {
            control.setErrors({ DateOfBirth: true });
            return { DateOfBirth: true };
         }

         return null;
      }
   }

   static readonly greaterThanControl = (controlName: string, matchingControlName: string): ValidatorFn => {
      return (formGroup: AbstractControl): ValidationErrors | null => {
         const dateStr: string | null = formGroup.get(controlName)?.value;
         const maxDateStr: string | null = formGroup.get(matchingControlName)?.value;

         if (!dateStr || !maxDateStr) {
            formGroup.get(matchingControlName)?.setErrors({ greaterThanControl: true });
            return { greaterThanControl: true };
         }

         const date = DateUtil.convertTimeToDate(dateStr);
         const maxDate = DateUtil.convertTimeToDate(maxDateStr);

         // check if date is valid and person is at least 18 years old
         if (isNaN(date.getTime()) || date >= maxDate) {
            formGroup.get(matchingControlName)?.setErrors({ greaterThanControl: true });
            return { greaterThanControl: true };
         }

         return null;
      }
   }

   static readonly lessThan = (maxDate: Date): ValidatorFn => {
      return (control: AbstractControl): ValidationErrors | null => {
         const dateStr: string | null = control?.value;

         if (!dateStr) {
            control.setErrors({ lessThan: true });
            return { lessThan: true };
         }

         const date = new Date(dateStr);

         // check if date is valid and person is at least 18 years old
         if (isNaN(date.getTime()) || date > maxDate) {
            control.setErrors({ lessThan: true });
            return { lessThan: true };
         }

         return null;
      }
   }

   static readonly greaterThan = (minDate: Date): ValidatorFn => {
      return (control: AbstractControl): ValidationErrors | null => {
         const dateStr: string | null = control?.value;

         if (!dateStr) {
            control.setErrors({ greaterThan: true });
            return { greaterThan: true };
         }

         const date = new Date(dateStr);

         // check if date is valid and person is at least 18 years old
         if (isNaN(date.getTime()) || date < minDate) {
            control.setErrors({ greaterThan: true });
            return { greaterThan: true };
         }

         return null;
      }
   }
}
